



















import { defineComponent, onMounted, onUnmounted, Ref, ref } from '@vue/composition-api';

const name = 'ttam-target-summary-box-auto-height';
export default defineComponent({
  name,
  setup() {
    const textWrapper: Ref<HTMLElement | null> = ref(null);
    const textNode: Ref<HTMLElement | null> = ref(null);
    const isCollapse = ref(true);
    const toggle = () => (isCollapse.value = !isCollapse.value);

    // Mutation observe dom change
    const isShowCollapseHandler = ref(false);
    const callback = () => {
      const scrollHeight = textNode.value?.scrollHeight ?? 0;
      isShowCollapseHandler.value = scrollHeight > 40;
    };
    const observer = new MutationObserver(callback);

    onMounted(() => {
      if (textNode.value) {
        callback();
        observer.observe(textWrapper.value as Node, {
          childList: true,
          subtree: true,
        });
      }
    });
    onUnmounted(() => {
      observer.disconnect();
    });

    return {
      name,
      textWrapper,
      textNode,
      isCollapse,
      isShowCollapseHandler,

      toggle,
    };
  },
});
